import { Component, input } from '@angular/core';
import { ClientAppointmentsTable } from '../../../infrastructure/shared/components/client-appointments-table/client-appointments-table';

@Component({
  standalone: true,
  selector: 'app-admin-client-termini-tab',
  imports: [ClientAppointmentsTable],
  templateUrl: './admin-client-termini-tab.html',
  styleUrl: './admin-client-termini-tab.scss',
})
export class AdminClientTerminiTab {
  clientId = input.required<string>();
}
